import { render, staticRenderFns } from "./VehiclePresenceModal.vue?vue&type=template&id=c5041008"
import script from "./VehiclePresenceModal.vue?vue&type=script&lang=js"
export * from "./VehiclePresenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports